// This file is auto-generated by @hey-api/openapi-ts

import type { RequestResult } from '../client';
import { client } from '../client.gen';
import type { Options } from '../sdk.gen';
import type { VideoCaptionUsingGetData, VideoCaptionUsingGetErrors, VideoCaptionUsingGetResponses, VideoEraseUsingGetData, VideoEraseUsingGetErrors, VideoEraseUsingGetResponses } from '../types.gen';

export class DesktopOssStsControllerService {
    /**
     * videoCaption
     */
    public static videoCaptionUsingGet<ThrowOnError extends boolean = false>(options?: Options<VideoCaptionUsingGetData, ThrowOnError>): RequestResult<VideoCaptionUsingGetResponses, VideoCaptionUsingGetErrors, ThrowOnError> {
        return (options?.client ?? client).get<VideoCaptionUsingGetResponses, VideoCaptionUsingGetErrors, ThrowOnError>({ url: '/v1/desktop/oss/sts/video-caption', ...options });
    }
    
    /**
     * videoErase
     */
    public static videoEraseUsingGet<ThrowOnError extends boolean = false>(options?: Options<VideoEraseUsingGetData, ThrowOnError>): RequestResult<VideoEraseUsingGetResponses, VideoEraseUsingGetErrors, ThrowOnError> {
        return (options?.client ?? client).get<VideoEraseUsingGetResponses, VideoEraseUsingGetErrors, ThrowOnError>({ url: '/v1/desktop/oss/sts/video-erase', ...options });
    }
}
